import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FormSubmissionList } from './FormSubmissionList';
import { FormSubmissionDetails } from './FormSubmissionDetails';

export function FormSubmissionsApp() {
  // Listen for form submissions from iframe (running on different port)
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Check if this is a form submission message
      if (event.data && event.data.type === 'ARKA_FORM_SUBMISSION') {
        const submission = event.data.payload;
        console.log('Received form submission via postMessage:', submission);

        // Save to localStorage
        const existingSubmissions = JSON.parse(
          localStorage.getItem('arka_form_submissions') || '[]'
        );
        existingSubmissions.push(submission);
        localStorage.setItem('arka_form_submissions', JSON.stringify(existingSubmissions));

        console.log('Saved to localStorage:', submission);

        // Trigger a page refresh to show the new submission
        window.location.reload();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<FormSubmissionList />} />
      <Route path="/:id" element={<FormSubmissionDetails />} />
      <Route path="*" element={<Navigate to="/forms" replace />} />
    </Routes>
  );
}
